import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderCissieEaster from "../../../../src/content/cissieeasterdevotional/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderCissieEaster,
  React
};